import { forwardRef, useId, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { InputHTMLAttributes } from 'react';

type InputPasswordProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

export const InputPassword = forwardRef<HTMLInputElement, InputPasswordProps>(
  ({ className, ...props }, ref) => {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);
    const generatedId = useId();
    const id = props.id ?? generatedId;

    const toggleVisibility = () => {
      setIsVisible((prev) => !prev);
    };

    return (
      <div className="input-password">
        <input
          {...props}
          ref={ref}
          id={id}
          type={isVisible ? 'text' : 'password'}
          className={`${className ?? ''} input-password__input`}
        />
        <button
          type="button"
          className="input-password__toggle"
          onClick={toggleVisibility}
          aria-label={
            isVisible
              ? t('common.altText.closeEye')
              : t('common.altText.openEye')
          }
          aria-pressed={isVisible}
          aria-controls={id}
        >
          <img
            src={isVisible ? '/eye-slash.svg' : '/eye.svg'}
            alt=""
            className="input-password__icon"
          />
        </button>
      </div>
    );
  },
);

InputPassword.displayName = 'InputPassword';
